import request from '@/utils/request'
import { member, personal, sms, user } from '@/config/apis'

// 登录
export function login(data) {
  return request({
    url: user.login,
    method: 'get',
    params: data
  })
}

// 注册
export function register(data) {
  return request({
    url: user.add,
    method: 'put',
    data: data
  })
}

// 新用户注册
export function register_new(data) {
  return request({
    url: user.register,
    method: 'put',
    data: data
  })
}

// 用户列表
export function list(data) {
  return request({
    url: user.list,
    method: 'get',
    params: data
  })
}

// 删除用户
export function del(data) {
  return request({
    url: user.del,
    method: 'delete',
    data: data
  })
}

// 编辑用户
export function edit(data) {
  return request({
    url: user.edit,
    method: 'post',
    data: data
  })
}

// 项目成员，搜索新成员
export function search(data) {
  return request({
    url: user.list,
    method: 'get',
    params: data
  })
}

// 项目成员，添加新成员
export function add(data) {
  return request({
    url: member.adds,
    method: 'put',
    data: data
  })
}

// 项目成员，修改新成员
export function up(data) {
  return request({
    url: member.upRole,
    method: 'post',
    data: data
  })
}

// 项目成员，删除新成员
export function remove(data) {
  return request({
    url: member.remove,
    method: 'delete',
    data: data
  })
}

// 项目成员，搜索新成员
export function searchUser(data) {
  return request({
    url: member.search,
    method: 'get',
    params: data
  })
}

// 发送短信
export function sendSms(data) {
  return request({
    url: sms.register,
    method: 'post',
    data: data
  })
}

// 重置密码
export function reset(data) {
  return request({
    url: user.reset,
    method: 'post',
    data: data
  })
}

// 获取邀请链接
export function getInviteLink(data) {
  return request({
    url: member.invite,
    method: 'get',
    params: data
  })
}

// 个人信息--更新
export function userInfoUpdate(data) {
  return request({
    url: personal.edit,
    method: 'post',
    data: data
  })
}

// 个人信息--修改密码
export function userInfoUpdatePassword(data) {
  return request({
    url: personal.resetPwd,
    method: 'post',
    data: data
  })
}

// 成员管理--同意加入项目
export function agreeJoin(data) {
  return request({
    url: member.agree,
    method: 'post',
    data: data
  })
}

// 成员管理--拒绝加入项目
export function refuseJoin(data) {
  return request({
    url: member.refuse,
    method: 'post',
    data: data
  })
}

// 成员管理--退出
export function quit(data) {
  return request({
    url: member.exit,
    method: 'delete',
    data: data
  })
}

// iframe 登陆
export function iframeLogin(data) {
  return request({
    url: user.iframeLogin,
    method: 'post',
    data: data
  })
}